import React, { FC } from 'react';
import { Group } from '@mantine/core';
import { ReactComponent as IconMinus } from '../img/iconMinus.svg';
import { EmployedsFilterLabel } from './EmployedsFilterLabel';
import { EmployedsFilterInput } from './EmployedsFilterInput';

export interface FilterAmountRangeProps {
  fromValue: string | number;
  toValue: string | number;
  onFromChange: (value: string | number) => void;
  onToChange: (value: string | number) => void;
  fromPlaceholder?: string;
  toPlaceholder?: string;
  label?: string;
  className?: string;
  show?: boolean;
  hideSearchIcon?: boolean;
}

export const EmployedsFilterAmountRange: FC<FilterAmountRangeProps> = ({
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  fromPlaceholder = '0',
  toPlaceholder = '1 000 000',
  label,
  className,
  show,
  hideSearchIcon = false,
}) => {
  return (
    <div className={className}>
      {label && <EmployedsFilterLabel>{label}</EmployedsFilterLabel>}
      <Group gap='8px' align='center' bg='#F1F4F9'>
        <div style={{ flex: 1 }}>
          <EmployedsFilterInput
            type='number'
            value={fromValue}
            onChange={onFromChange}
            placeholder={fromPlaceholder}
            min={0}
            show={show}
            hideSearchIcon={hideSearchIcon}
          />
        </div>
        <IconMinus />
        <div style={{ flex: 1 }}>
          <EmployedsFilterInput
            type='number'
            value={toValue}
            onChange={onToChange}
            placeholder={toPlaceholder}
            min={0}
            show={show}
            hideSearchIcon={hideSearchIcon}
          />
        </div>
      </Group>
    </div>
  );
};
